/* eslint-disable jsx-a11y/alt-text */
import { ArticleTable } from '../ArticleTable'
import { ArticleList } from '../List'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { useIsTablet } from '@hooks/use-media-query'

import {
  ArticleBlockText,
  ArticleBlockImage,
  ArticleBlockTitle,
  ArticleBlockParagraph,
  Quote,
  Header,
  Subtitle,
  Button,
  TextWrapper,
  ImageContainer,
} from './styles'
import { SwitcherProps } from './types'

export function Switcher({ block }: SwitcherProps) {
  const { type, value, marginTop, paddingLeft, alignSelf, maxWidth, ...rest } =
    block

  const isTablet = useIsTablet()

  switch (type) {
    case 'text': {
      return (
        <ArticleBlockText marginTop={marginTop} paddingLeft={paddingLeft}>
          {value}
        </ArticleBlockText>
      )
    }

    case 'image': {
      return (
        <ArticleBlockImage marginTop={marginTop} paddingLeft={paddingLeft}>
          <ImageWithPlaceholder {...value} />
        </ArticleBlockImage>
      )
    }

    case 'custom-image': {
      return (
        <ImageContainer>
          <ImageWithPlaceholder {...value} />
        </ImageContainer>
      )
    }

    case 'title': {
      return (
        <ArticleBlockTitle
          textColor="accent"
          marginTop={marginTop}
          paddingLeft={paddingLeft}
        >
          {value}
        </ArticleBlockTitle>
      )
    }

    case 'quote': {
      return (
        <Quote marginTop={marginTop} paddingLeft={paddingLeft} {...rest}>
          <blockquote>{value}</blockquote>
        </Quote>
      )
    }

    case 'list': {
      const { listType = 'ul' } = block

      return (
        <ArticleList
          type={listType}
          items={value}
          marginTop={marginTop}
          paddingLeft={paddingLeft}
          {...rest}
        />
      )
    }

    case 'subtitle': {
      const { textColor, subtitleLevel } = block

      return (
        <ArticleBlockTitle
          as={subtitleLevel || 'h2'}
          textColor={textColor}
          marginTop={marginTop}
          paddingLeft={paddingLeft}
        >
          {value}
        </ArticleBlockTitle>
      )
    }

    case 'paragraph': {
      const { mobileMarginTop } = block

      return (
        <ArticleBlockParagraph
          marginTop={marginTop}
          mobileMarginTop={mobileMarginTop}
          paddingLeft={paddingLeft}
          alignSelf={alignSelf}
          maxWidth={maxWidth}
        >
          {value}
        </ArticleBlockParagraph>
      )
    }

    case 'table': {
      return <ArticleTable config={value} marginTop={marginTop} />
    }

    case 'clickable-image': {
      const handleClick = () => {
        window.open(value.link, '_blank')
      }
      return (
        <ArticleBlockImage
          onClick={handleClick}
          marginTop={marginTop}
          paddingLeft={paddingLeft}
        >
          <ImageWithPlaceholder {...value} />
        </ArticleBlockImage>
      )
    }

    case 'custom': {
      return value
    }

    case 'image-with-button': {
      const { image, imageMobile } = block

      return (
        <ArticleBlockImage marginTop={marginTop} paddingLeft={paddingLeft}>
          <ImageWithPlaceholder {...(isTablet ? imageMobile : image)} />
          <TextWrapper>
            <Header as="h3">{value.title}</Header>
            {value.subtitle && <Subtitle as="h4">{value.subtitle}</Subtitle>}
            <Button
              id={value.id}
              label={value.buttonLabel}
              backgroundColor="secondary"
              backgroundColorOnHover="secondary"
            />
          </TextWrapper>
        </ArticleBlockImage>
      )
    }

    default:
      return null
  }
}
